module.exports = new __parcel__URL__("luigis-mansion.446ffadb.jpg").toString();